export default class FileUtils {
  static MAX_FILE_SIZE = 1 * 1024 * 1024;

  static formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / (k ** i)).toFixed(2)) + ' ' + sizes[i];
  }

  static isFileTypeAllowed(file, allowedTypes = ['.jpg', '.jpeg', '.png', '.gif']) {
    if (!file) return false;

    const fileName = file.name.toLowerCase();
    return allowedTypes.some(type => fileName.endsWith(type.toLowerCase()));
  }

  static validateImageFile(file, options = {}) {
    const {
      maxSize = this.MAX_FILE_SIZE,
      allowedTypes = ['.jpg', '.jpeg', '.png', '.gif']
    } = options;

    if (!file) {
      return { isValid: false, error: 'Nie wybrano pliku' };
    }

    if (file.size > maxSize) {
      return {
        isValid: false,
        error: `Plik jest zbyt duży. Maksymalny rozmiar to ${this.formatFileSize(maxSize)}. Wybierz mniejszy plik.`
      };
    }

    if (!this.isFileTypeAllowed(file, allowedTypes)) {
      return {
        isValid: false,
        error: `Nieprawidłowy typ pliku. Dozwolone formaty: ${allowedTypes.join(', ')}`
      };
    }

    return { isValid: true, error: null };
  }
}
